import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import map from 'lodash/map';
import { Spin, Typography, Select, Button, Table, Modal, Tag } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import ContentPageHeader from '../../components/contentPageHeader';
import {
  ROLE_MARKETING_MANAGER,
  ROLE_MARKETING_ADMIN,
} from '../../constants/roles';
import {
  generatePaginationObj,
  hasAnyPermission,
} from '../../utilities/helpers';
import { orderDescription } from '../../constants/manageOrder';
import { orderManagement } from '../../redux/actions/manageOrderActions';
import { limitOpions } from '../../constants/paginationLimit';
import OrderDetails from '../../components/manageOrders/orderDetails';

const { Text } = Typography;
const { Option } = Select;

const Orders = () => {
  const [loading, setLoading] = useState(false);
  const selectedCompany = useSelector((state) =>
    get(state, 'auth.selectedCompany')
  );
  const userComapnies = useSelector((state) =>
    get(state, 'auth.userCompanies')
  );
  const role = useSelector((state) => get(state, 'auth.role'));
  const [orderDetailsInfo, setOrderDetailsInfo] = useState({
    visible: false,
    data: null,
  });
  const dispatch = useDispatch();
  const [sampleOrders, setSampleOrders] = useState({
    data: [],
    filters: null,
    sorters: null,
    pagination: {
      offset: 0,
      limit: 10,
      total: 0,
      current: 1,
    },
    filterChips: null,
  });
  const [retailerList, setRetailerList] = useState([]);
  const [tempFilter, setTempFilter] = useState({
    filterDropdown: {
      brand: false,
    },
    tempFilterChips: {
      brand: undefined,
    },
    filterValues: {
      partner_retailer_id: undefined,
      company_id: undefined,
    },
  });

  const { offset, limit } = generatePaginationObj(
    get(sampleOrders, 'pagination.current'),
    get(sampleOrders, 'pagination.limit')
  );

  const fetchRetailerList = () => {
    setLoading(true);
    dispatch(orderManagement('list.partner_retailers'))
      .then((result) => {
        setLoading(false);
        setRetailerList(get(result, 'data'));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const fetchSampleOrders = (
    page = 1,
    filterObj = {},
    sorterObj = {},
    filterChipsObj = {},
    perPageLimit = get(sampleOrders, 'pagination.limit')
  ) => {
    setLoading(true);
    const pageObj = generatePaginationObj(page, perPageLimit);
    dispatch(
      orderManagement('list.orders', {
        company_id: get(selectedCompany, 'id'),
        ...pageObj,
        filters: filterObj,
      })
    )
      .then((result) => {
        setLoading(false);
        setSampleOrders({
          data: get(result, 'data'),
          filters: filterObj,
          sorters: sorterObj,
          pagination: {
            ...pageObj,
            total: get(result, 'total'),
            current: page,
          },
          filterChips: filterChipsObj,
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const toggleModal = (record) => {
    setOrderDetailsInfo({
      visible: !get(orderDetailsInfo, 'visible'),
      data: record,
    });
  };

  useEffect(() => {
    fetchSampleOrders();
    fetchRetailerList();
  }, [selectedCompany]);

  const removeFilterChip = (tempFilterChipsKey, valuesKey, record) => {
    const tempFilterChipsKeyRecord = get(
      tempFilter,
      `tempFilterChips.${tempFilterChipsKey}`
    ).filter((obj) => obj.value !== record.value);
    const valuesKeyRecord = get(tempFilter, `filterValues.${valuesKey}`).filter(
      (value) => value !== record.value
    );
    setTempFilter({
      ...tempFilter,
      tempFilterChips: {
        ...get(tempFilter, 'tempFilterChips'),
        [tempFilterChipsKey]: tempFilterChipsKeyRecord,
      },
      filterValues: {
        ...get(tempFilter, 'filterValues'),
        [valuesKey]: valuesKeyRecord.length ? valuesKeyRecord : undefined,
      },
    });
    fetchSampleOrders(
      get(sampleOrders, 'pagination.current'),
      {
        ...get(tempFilter, 'filterValues'),
        [valuesKey]: valuesKeyRecord.length ? valuesKeyRecord : undefined,
      },
      get(sampleOrders, 'sorters'),
      get(tempFilter, 'tempFilterChips')
    );
  };

  return (
    <Spin spinning={loading}>
      <div>
        <div>
          <ContentPageHeader
            border
            title={[
              <Text className="content-page-header-heading">
                Manage Orders
              </Text>,
              <RightOutlined className="content-page-header-heading" />,
              <Text className="content-page-header-heading">
                Sample Orders
              </Text>,
            ]}
            extras={[]}
          />
        </div>

        <div className="d-flex filter" style={{ alignItems: 'flex-start' }}>
          <div className="filter-boxes">
            <div className="d-flex filter-items">
              {hasAnyPermission(
                [ROLE_MARKETING_ADMIN, ROLE_MARKETING_MANAGER],
                [get(role, 'role_code')]
              ) && (
                <div>
                  <Select
                    mode="multiple"
                    showSearch
                    showArrow
                    placeholder="Brand"
                    value={
                      get(tempFilter, 'filterDropdown.brand')
                        ? get(tempFilter, 'filterValues.company_id')
                        : undefined
                    }
                    filterOption={(input, option) => {
                      return (
                        get(option, 'children').toLowerCase() ?? ''
                      ).includes(input.toLowerCase());
                    }}
                    style={{
                      width: '150px',
                    }}
                    tagRender={() => null}
                    onDropdownVisibleChange={(open) => {
                      setTempFilter({
                        ...tempFilter,
                        filterDropdown: {
                          ...get(tempFilter, 'filterDropdown'),
                          brand: open,
                        },
                      });
                    }}
                    onChange={(value, option) => {
                      setTempFilter({
                        ...tempFilter,
                        tempFilterChips: {
                          ...get(tempFilter, 'tempFilterChips'),
                          brand: option,
                        },
                        filterValues: {
                          ...get(tempFilter, 'filterValues'),
                          company_id: value,
                        },
                      });
                    }}
                  >
                    {map(userComapnies, (company) => (
                      <Option
                        key={get(company, 'Company.id')}
                        value={get(company, 'Company.id')}
                      >
                        {get(company, 'Company.name')}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}
              <div>
                <Select
                  placeholder="Retailer"
                  value={get(tempFilter, 'filterValues.partner_retailer_id')}
                  onChange={(value) => {
                    setTempFilter({
                      ...tempFilter,
                      filterValues: {
                        ...get(tempFilter, 'filterValues'),
                        partner_retailer_id: value,
                      },
                    });
                  }}
                >
                  {map(retailerList, (retailer) => (
                    <Option
                      key={get(retailer, 'id')}
                      value={get(retailer, 'id')}
                    >
                      {get(retailer, 'name')}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>

            {get(sampleOrders, 'filterChips') && (
              <div className="d-flex filter-items mt-10">
                {map(get(sampleOrders, 'filterChips.brand'), (brandObj) => (
                  <Tag
                    key={get(brandObj, 'value')}
                    closable
                    color="#009ea8"
                    style={{ padding: '3px 7px' }}
                    onClose={() => {
                      removeFilterChip('brand', 'company_id', brandObj);
                    }}
                  >
                    {get(brandObj, 'children')}
                  </Tag>
                ))}
              </div>
            )}
          </div>

          <div className="d-flex filter-btns">
            <Button
              className="default-btn"
              block
              onClick={() => {
                setTempFilter({
                  filterDropdown: {
                    brand: undefined,
                  },
                  tempFilterChips: {
                    brand: undefined,
                  },
                  filterValues: {
                    partner_retailer_id: undefined,
                  },
                });
                fetchSampleOrders();
              }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              block
              onClick={() => {
                fetchSampleOrders(
                  get(sampleOrders, 'pagination.current'),
                  get(tempFilter, 'filterValues'),
                  get(sampleOrders, 'sorters'),
                  get(tempFilter, 'tempFilterChips')
                );
              }}
            >
              Apply Filter
            </Button>
          </div>
        </div>

        <div className="d-flex" style={{ justifyContent: 'space-between' }}>
          <div>
            Showing {get(sampleOrders, 'data').length ? offset + 1 : 0}-
            {get(sampleOrders, 'pagination.total') < limit ||
            get(sampleOrders, 'pagination.total') < offset + limit
              ? get(sampleOrders, 'pagination.total')
              : offset + limit}{' '}
            of {get(sampleOrders, 'pagination.total')} results
          </div>

          <div className="d-flex" style={{ gap: '9px' }}>
            <div>Results per page</div>
            <div>
              <Select
                value={get(sampleOrders, 'pagination.limit')}
                onChange={(value) => {
                  fetchSampleOrders(
                    get(sampleOrders, 'pagination.current'),
                    get(sampleOrders, 'filters'),
                    get(sampleOrders, 'sorters'),
                    get(tempFilter, 'tempFilterChips'),
                    value
                  );
                }}
                options={limitOpions}
              />
            </div>
          </div>
        </div>

        <div className="product-table-container">
          <Table
            size="small"
            rowKey="id"
            className="product-table"
            dataSource={get(sampleOrders, 'data')}
            columns={orderDescription({ toggleModal })}
            onChange={(paginationObj, filterObj, sorterObj) => {
              fetchSampleOrders(
                get(paginationObj, 'current'),
                get(sampleOrders, 'filters'),
                get(sorterObj, 'order')
                  ? {
                      sortBy: get(sorterObj, 'field'),
                      sortDir:
                        get(sorterObj, 'order') === 'ascend' ? 'ASC' : 'DESC',
                    }
                  : {},
                get(tempFilter, 'tempFilterChips')
              );
            }}
            pagination={{
              showSizeChanger: false,
              position: ['bottomCenter'],
              hideOnSinglePage: true,
              pageSize: get(sampleOrders, 'pagination.limit'),
              total: get(sampleOrders, 'pagination.total'),
              current: get(sampleOrders, 'pagination.current'),
            }}
          />
        </div>
      </div>

      <Modal
        width="32%"
        className="common-modal product-image-modal"
        closable={false}
        open={get(orderDetailsInfo, 'visible')}
        onCancel={toggleModal}
        onOk={toggleModal}
        footer={false}
        maskClosable={false}
      >
        <div className="login-container" style={{ boxShadow: 'none' }}>
          <div className="heading">
            <LeftOutlined
              className="back-btn"
              onClick={() => {
                toggleModal(get(orderDetailsInfo, 'data'));
              }}
            />
            Customer details Collected
          </div>

          <div className="mt-30">
            <OrderDetails orderDetailsInfo={orderDetailsInfo} />
          </div>
        </div>
      </Modal>
    </Spin>
  );
};

export default Orders;
